"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkoutItemsReducer = void 0;
var actions_1 = require("../../utils/actions");
var actions_2 = require("./actions");
var initialState = {};
var GIFT_CARD_SKU_KEY = 'osmo_e_gift_card';
var handleExtraInfo = function (state, skuKey, itemDetails) {
    var _a, _b, _c;
    var cartItem;
    if (skuKey === GIFT_CARD_SKU_KEY) {
        var giftCardsData = ((_b = (_a = state[skuKey]) === null || _a === void 0 ? void 0 : _a.extraInfo) === null || _b === void 0 ? void 0 : _b.giftCards) || [];
        ((_c = itemDetails.extraInfo) === null || _c === void 0 ? void 0 : _c.giftCard) &&
            giftCardsData.push(itemDetails.extraInfo.giftCard);
        cartItem = __assign(__assign({}, state[skuKey]), { extraInfo: __assign(__assign({}, ((state[skuKey] || {}).extraInfo || {})), { giftCards: giftCardsData }) });
    }
    return cartItem;
};
var addItem = function (state, action) {
    var _a;
    var _b;
    var _c = action.payload, skuKey = _c.skuKey, item = _c.item;
    var itemWithExtraInfo = handleExtraInfo(state, skuKey, item);
    return __assign(__assign({}, state), (_a = {}, _a[skuKey] = __assign(__assign(__assign({}, item), (itemWithExtraInfo || {})), { quantity: (((_b = state === null || state === void 0 ? void 0 : state[skuKey]) === null || _b === void 0 ? void 0 : _b.quantity) || 0) + item.quantity }), _a));
};
var addItems = function (state, action) {
    var items = action.payload.items;
    return __assign(__assign({}, state), items.reduce(function (acc, item) {
        var _a;
        var _b;
        var itemWithExtraInfo = handleExtraInfo(state, item.skuKey, item);
        return __assign(__assign({}, acc), (_a = {}, _a[item.skuKey] = __assign(__assign(__assign({}, item), (itemWithExtraInfo || {})), { quantity: (((_b = acc[item.skuKey]) === null || _b === void 0 ? void 0 : _b.quantity) || 0) + item.quantity }), _a));
    }, {}));
};
var updateItems = function (state, action) {
    var items = action.payload.items;
    return __assign({}, items.reduce(function (acc, item) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[item.skuKey] = item, _a)));
    }, {}));
};
var setItemQuantity = function (state, action) {
    var _a;
    var _b = action.payload, skuKey = _b.skuKey, quantity = _b.quantity;
    return __assign(__assign({}, state), (_a = {}, _a[skuKey] = __assign(__assign({}, state[skuKey]), { quantity: quantity }), _a));
};
var updateItem = function (state, action) {
    var _a;
    var _b = action.payload, skuKey = _b.skuKey, itemDetails = _b.itemDetails;
    return __assign(__assign({}, state), (_a = {}, _a[skuKey] = __assign(__assign(__assign({}, state[skuKey]), { skuKey: skuKey }), itemDetails), _a));
};
var removeItem = function (state, action) {
    if (!state)
        return state;
    var skuKey = action.payload.skuKey;
    var stateClone = JSON.parse(JSON.stringify(state));
    delete stateClone[skuKey];
    return stateClone;
};
var itemsReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    if ((0, actions_1.isType)(action, actions_2.addItemAction)) {
        return addItem(state, action);
    }
    else if ((0, actions_1.isType)(action, actions_2.addItemsAction)) {
        return addItems(state, action);
    }
    else if ((0, actions_1.isType)(action, actions_2.updateItemsAction)) {
        return updateItems(state, action);
    }
    else if ((0, actions_1.isType)(action, actions_2.updateItemAction)) {
        return updateItem(state, action);
    }
    else if ((0, actions_1.isType)(action, actions_2.setItemQuantityAction)) {
        return setItemQuantity(state, action);
    }
    else if ((0, actions_1.isType)(action, actions_2.removeItemAction)) {
        return removeItem(state, action);
    }
    else if ((0, actions_1.isType)(action, actions_2.clearAllItemsAction)) {
        return initialState;
    }
    else {
        return state;
    }
};
var checkoutItemsReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    if ((0, actions_1.isType)(action, actions_2.addCheckoutItemAction)) {
        return addItem(state, action);
    }
    else if ((0, actions_1.isType)(action, actions_2.addCheckoutItemsAction)) {
        return addItems(state, action);
    }
    else if ((0, actions_1.isType)(action, actions_2.updateCheckoutItemsAction)) {
        return updateItems(state, action);
    }
    else if ((0, actions_1.isType)(action, actions_2.updateCheckoutItemAction)) {
        return updateItem(state, action);
    }
    else if ((0, actions_1.isType)(action, actions_2.setCheckoutItemQuantityAction)) {
        return setItemQuantity(state, action);
    }
    else if ((0, actions_1.isType)(action, actions_2.removeCheckoutItemAction)) {
        return removeItem(state, action);
    }
    else if ((0, actions_1.isType)(action, actions_2.clearAllCheckoutItemsAction)) {
        return initialState;
    }
    else {
        return state;
    }
};
exports.checkoutItemsReducer = checkoutItemsReducer;
exports.default = itemsReducer;
